function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import orderBy from 'lodash/orderBy';
import { isAnyDistrict } from '@myap/metadata';
import { Autosuggest } from '..';
import { apricot } from '../../profile';
import Dropdown from '../apricot/Dropdown';
import styles from '../../../sass/navigation.module.scss';

var DropdownSearch = function DropdownSearch(props) {
  var container = useRef(null);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var label = props.label,
      id = props.id,
      items = props.items,
      hasAlert = props.hasAlert,
      current = props.current,
      alignDropdownRight = props.alignDropdownRight;
  var _apricot$utils$keys = apricot().utils.keys,
      ENTER = _apricot$utils$keys.ENTER,
      ESC = _apricot$utils$keys.ESC;
  var parent = isAnyDistrict(current.role) ? items.find(function (i) {
    return i.orgId === current.orgId;
  }) : items.find(function (i) {
    return i.orgId === current.parentOrgId;
  });

  var processSelection = function processSelection(selection) {
    selection.action();
    setOpen(false);
    setValue(null);
  };

  var closeDropdownOnClickOut = function closeDropdownOnClickOut(e) {
    if (!container.current.contains(e.target)) setOpen(false);
  };

  var closeDropdownOnEscape = function closeDropdownOnEscape(e) {
    if (e.keyCode === ESC) setOpen(false);
  };

  useEffect(function () {
    document.addEventListener('click', closeDropdownOnClickOut);
    document.addEventListener('keydown', closeDropdownOnEscape);
    return function () {
      document.removeEventListener('click', closeDropdownOnClickOut);
      document.removeEventListener('keydown', closeDropdownOnEscape);
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "dropdown ".concat(styles['org-search']),
    ref: container
  }, /*#__PURE__*/React.createElement("a", {
    id: id,
    href: "#",
    "aria-expanded": open,
    "aria-controls": "dropdown-".concat(id),
    role: "button",
    onClick: function onClick(e) {
      e.preventDefault();
      setOpen(!open);
    }
  }, label, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Press Enter for Dropdown.")), /*#__PURE__*/React.createElement("div", {
    className: "dropdown-menu ".concat(styles['org-search-dropdown'], " ").concat(alignDropdownRight ? styles['org-search-right'] : ''),
    "aria-labelledby": id,
    role: "region",
    id: "dropdown-".concat(id)
  }, /*#__PURE__*/React.createElement(Autosuggest, {
    turnOnClickOutListener: false,
    minCharacterSearchLength: 0,
    className: "".concat(styles['org-search-autosuggest'], " ").concat(hasAlert ? styles['with-alerts'] : ''),
    name: "searchOrg",
    placeholder: "Search by organization name or AI code",
    onChange: function onChange(e) {
      return setValue(e.target.value);
    },
    value: value,
    renderSuggestion: function renderSuggestion(props) {
      return props.label;
    },
    selectSuggestion: processSelection,
    fetchSuggestions: function fetchSuggestions(val) {
      var suggestions = items.filter(function (child) {
        return child.searchValues.find(function (v) {
          return v && v.toLowerCase().includes(val.toLowerCase());
        });
      }).slice(0, 10);
      return {
        suggestions: suggestions,
        total: suggestions.length
      };
    },
    footer: parent ? {
      component: function component(props) {
        return /*#__PURE__*/React.createElement("button", _extends({}, props, {
          type: "button",
          className: styles['org-search-return-btn'],
          onClick: function onClick() {
            return processSelection(parent);
          },
          onKeyDown: function onKeyDown(e) {
            if (e.keyCode === ENTER) processSelection(parent);else if (props.onKeyDown) props.onKeyDown(e);
          }
        }), /*#__PURE__*/React.createElement("span", null, "Return to ", parent.label));
      },
      alwaysVisible: true
    } : null
  })));
};

var DropdownOrgLabel = function DropdownOrgLabel(_ref) {
  var orgName = _ref.orgName,
      role = _ref.role,
      notAbleToOrder = _ref.notAbleToOrder,
      aiCode = _ref.aiCode,
      orgId = _ref.orgId,
      _ref$showCode = _ref.showCode,
      showCode = _ref$showCode === void 0 ? false : _ref$showCode;
  return /*#__PURE__*/React.createElement(React.Fragment, null, notAbleToOrder ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
    className: "cb-glyph cb-exclamation ".concat(styles['org-alert']),
    id: "org-dropdown-".concat(orgId),
    "aria-hidden": true
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Alert: Participation form needs to be signed")) : null, /*#__PURE__*/React.createElement("span", {
    className: isAnyDistrict(role) ? styles['org-parent'] : ''
  }, orgName, showCode && aiCode ? " (".concat(aiCode, ")") : ''));
};
/* options:
- selectedOrgId
- roles: [{ orgId, notAbleToOrder, role, aiCode, parentOrgId, parentOrgName }] // include parentOrgId only if it is a district admin
- action
- minSearchLength: minimum number of roles needed before org dropdown switches to search dropdown
*/


export default (function (_ref2) {
  var selectedOrgId = _ref2.selectedOrgId,
      roles = _ref2.roles,
      _action = _ref2.action,
      _ref2$minSearchLength = _ref2.minSearchLength,
      minSearchLength = _ref2$minSearchLength === void 0 ? 10 : _ref2$minSearchLength,
      alignDropdownRight = _ref2.alignDropdownRight;
  var current = roles.find(function (r) {
    return r.orgId === selectedOrgId;
  }) || roles[0];
  var hasAlert = roles.find(function (r) {
    return r.notAbleToOrder;
  });
  var isSearchDropdown = roles.length > minSearchLength;
  var items = roles.map(function (r) {
    return {
      label: DropdownOrgLabel(_objectSpread(_objectSpread({}, r), {}, {
        showCode: isSearchDropdown
      })),
      action: function action() {
        return _action(r);
      },
      isParent: isAnyDistrict(r.role),
      searchValues: [r.orgName, r.aiCode],
      orgId: r.orgId
    };
  });
  var alphabeticalItems = orderBy(items, [function (item) {
    return item.searchValues[0];
  }], ['asc']);
  var options = isSearchDropdown ? {
    hasAlert: hasAlert
  } : {
    className: "".concat(styles['org-dropdown'], " ").concat(hasAlert ? styles['dropdown-with-alert'] : ''),
    useApricotDropdown: false,
    triggerDisplaysAsCurrentSelection: true
  };
  var Component = isSearchDropdown ? DropdownSearch : Dropdown;
  return /*#__PURE__*/React.createElement(Component, _extends({
    id: "orgToggleDropdown",
    label: DropdownOrgLabel(current),
    items: alphabeticalItems,
    current: current,
    alignDropdownRight: alignDropdownRight
  }, options));
});